import { useEffect, useRef } from 'react'
import { useControls } from 'react-zoom-pan-pinch'

export const ZoomResetterOnHeightChange = ({ height }: { height?: number }) => {
  const { zoomIn } = useControls()

  const zoomInRef = useRef(zoomIn)
  useEffect(() => {
    zoomInRef.current = zoomIn
  }, [zoomIn])

  useEffect(() => {
    zoomInRef.current(0.01, 1)
  }, [height])

  return null
}
